module.exports = __webpack_public_path__ + "img/svg14.0887d297.svg";